import { useState } from 'react';

import { Steps } from './constants';
import { ThemeStep } from './steps/theme';
import { ToneStep } from './steps/tone';

import { MessageTipsDrawerProps } from './types';

import * as S from './styles';

export const MessageTipsDrawer: React.FC<MessageTipsDrawerProps> = ({
  isOpen,
  onClose,
}) => {
  const [currentStep, setCurrentStep] = useState<Steps>(Steps.THEME);
  const [triggerCode, setTriggerCode] = useState<string>('');

  const handleCloseDrawer = () => {
    if (onClose) onClose();
  };

  const handleNextStep = (code?: string) => {
    if (code) setTriggerCode(code);

    setCurrentStep(Steps.TONE);
  };

  const handlePreviousStep = () => {
    setCurrentStep(Steps.THEME);
  };

  return (
    <S.Container
      anchor="right"
      role="presentation"
      open={isOpen}
      onClose={handleCloseDrawer}
    >
      {currentStep === Steps.THEME && (
        <ThemeStep onClose={handleCloseDrawer} onNextStep={handleNextStep} />
      )}

      {currentStep === Steps.TONE && (
        <ToneStep
          onClose={handleCloseDrawer}
          onPreviousStep={handlePreviousStep}
          triggerCode={triggerCode}
        />
      )}
    </S.Container>
  );
};
